import store from '@/store';
import { WHATSAPP_DIGITAL_PRESCRIPTION } from '@/data/message-templates';
import { isMetaEnabled, isWhatsappWebEnabled } from '@/helpers/telemedicine';

export const SENT = 'sent';
export const WHATSAPP_WEB = 'whatsappWeb';

const FALLBACK_REASONS = ['templateNotApproved', 'whatsappNotEnabled'];

export function whatsappText({ patientName, professionalName, documentUrl }) {
  const { branch } = store.state.user;

  return WHATSAPP_DIGITAL_PRESCRIPTION
    .replace('[patient_name]', patientName ? patientName.split(' ')[0] : '')
    .replace('[professional_name]', professionalName || '')
    .replace('[document_link]', documentUrl || '')
    .replace('[facility_name]', branch && branch.name ? branch.name : '');
}

export function isWhatsappSendEnabled() {
  return isMetaEnabled() || isWhatsappWebEnabled();
}

function openWhatsappWeb(vm, { cellphone, url, buildText }) {
  if (!isWhatsappWebEnabled()) {
    vm.$toast.show(
      'O WhatsApp Web não está habilitado. Envie a receita impressa ou por outro canal.',
      { type: 'error' },
    );
    return null;
  }

  vm.$whatsappWeb.open(cellphone || '', buildText(url));
  return WHATSAPP_WEB;
}

async function shareUrl(vm, { shareRoute, params }) {
  const { data } = await vm.$httpX.post(shareRoute, params);
  return data.url;
}

export async function shareRecipeWhatsappWeb(vm, {
  cellphone, shareRoute, params = {}, buildText,
}) {
  if (!isWhatsappWebEnabled()) {
    return openWhatsappWeb(vm, { cellphone, url: null, buildText });
  }

  try {
    const url = await shareUrl(vm, { shareRoute, params });
    return openWhatsappWeb(vm, { cellphone, url, buildText });
  } catch (e) {
    vm.$toast.error(e);
    return null;
  }
}

export async function sendRecipeWhatsapp(vm, {
  cellphone,
  messageRoute,
  shareRoute,
  params = {},
  buildText,
  fallbackOnInvalidPhone = false,
}) {
  if (!isWhatsappSendEnabled()) {
    vm.$toast.show('Envio pelo WhatsApp não habilitado', { type: 'error' });
    return null;
  }

  if (!isMetaEnabled()) {
    return shareRecipeWhatsappWeb(vm, {
      cellphone, shareRoute, params, buildText,
    });
  }

  try {
    await vm.$httpX.post(messageRoute, { ...params, cellphone: cellphone || '' });
    vm.$toast.success('Receita enviada pelo WhatsApp');
    return SENT;
  } catch (e) {
    const data = e && e.response ? e.response.data : null;
    const reason = data ? data.reason : null;
    const canFallback = FALLBACK_REASONS.includes(reason)
      || (fallbackOnInvalidPhone && reason === 'invalidPhone' && isWhatsappWebEnabled());

    if (!canFallback) {
      vm.$toast.error(e);
      return null;
    }

    vm.$toast.show(data.message, { type: 'warning' });

    try {
      const url = data.url || await shareUrl(vm, { shareRoute, params });
      return openWhatsappWeb(vm, { cellphone, url, buildText });
    } catch (err) {
      vm.$toast.error(err);
      return null;
    }
  }
}

export default whatsappText;
